
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(8(46|73|86)|7(0|4|45)|353|360|535|968)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
